import {useCallback, useState} from 'react'

/**
 * Custom state hook that will only update state when the value changes.
 * Uses a strict-equality comparison to determine if the value changed
 */
export function useStateWithAvoidableReRenders<T>(initialState: T | (() => T)): [T, (value: T) => void] {
  const [state, setState] = useState<T>(initialState)

  // Reading the latest state inside a functional updater lets React bail out (Object.is)
  // when the value is unchanged, so we avoid extra re-renders in memo'd consumers without
  // a render-phase ref write.
  const setStateIfChanged = useCallback((newState: T) => {
    setState(prev => (newState !== prev ? newState : prev))
  }, [])

  return [state, setStateIfChanged]
}
